import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

const DropdownPaper = styled(Paper)(({ theme }) => ({
  boxShadow: theme.elevation[1],
}));

export default DropdownPaper;
